import type { Typography } from '../../style';
import DefaultTypography from '../default/Typography';
import RcmReportTypography from '../rcm-report/Typography';
import GreenTypographyModule from '../green/Typography';

const GreenTypography: Typography =
  process.env.USE_GREEN === 'true' || process.env.NODE_ENV === 'test' ? GreenTypographyModule : DefaultTypography;

export const getTypographyTheme = (theme: string): Typography => {
  switch (theme) {
    case 'rcm-report':
      return RcmReportTypography;

    case 'default':
      return DefaultTypography;

    default:
      return GreenTypography;
  }
};
